import React from "react";
import { motion } from "framer-motion";
import cleaningImage from "../assets/images/banerBack.jpg";
import logo from "../assets/images/logo.png";

const Contact = () => {
    return (
        <section
            id="contact"
            className="relative py-10 mb-10 mt-8 md:py-24 md:mb-24 md:mt-14 content-center"
        >
            <div className="grid grid-cols-1 md:grid-cols-2 container mx-auto px-4 md:mx-">
                {/* Logo Section */}
                <div className="hidden md:flex flex-col items-start justify-center mb-8 md:mb-0">
                    <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5 }}
                        className="flex flex-col items-start"
                    >
                        <img
                            src={logo}
                            alt="Golden Eagle Logo"
                            className="w-64 md:w-96 h-auto"
                            loading="lazy"
                            decoding="async"
                        />
                    </motion.div>
                </div>

                {/* Contact Info Section */}
                <div className="md:absolute md:right-0 md:top-10 md:w-[60%] md:h-full w-full h-auto">
                    <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5 }}
                        className="relative w-full h-full flex items-center md:p-8 p-0 text-white"
                        style={{
                            backgroundImage: `url(${cleaningImage})`,
                            backgroundBlend: "overlay",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                        }}
                    >
                        <div className="absolute inset-0 bg-black opacity-60 "></div>

                        <div className="relative z-10 ml-4 md:ml-10 ">
                            <h2 className="md:text-6xl text-2xl font-bold mt-8 md:mb-2 leading-tight ">
                                Looking{" "}
                                <span className="font-normal md:text-4xl ">
                                    for a
                                </span>
                            </h2>
                            <p className="md:text-6xl text-3xl text-[#FFD700] font-bold leading-tight">
                                Facility management services,
                            </p>
                            <p className="md:text-2xl text-lg md:mt-4 md:mb-6 mb-2 leading-snug">
                                We're ready to Provide services for you
                            </p>
                            <div className="md:text-6xl mb-8 text-2xl font-bold">
                                Call us :{" "}
                                <span className="text-white font-bold">
                                    076 649 6256
                                </span>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
